(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/big/assets/javascripts/views/big-statistics-tabs_desktop.js') >= 0) return;  svs.modules.push('/components/statistics/big/assets/javascripts/views/big-statistics-tabs_desktop.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.BigStatisticsTabs = Backbone.Marionette.View.extend({
    template: function() {
      return '';
    },

    log: new svs.core.log.Logger('svs.statistics.BigStatisticsTabs'),

    masonryInstances: [],

    initialize: function() {
      if (_.isObject(this.options) && this.options.preDraw) {
        this.setupTabs(this.options.preDraw);
        if (this.tabs) {
          this.statsTab = new svs.components.Tabs({
            el: this.$el,
            tabs: this.tabs,
            path: !!this.options.selectedTab,
            cacheCreated: true,
            solidNav: this.options.usePageScroll || false,
            defaultScroll: this.options.usePageScroll || false,
            slideOnDrag: !svs.core.detect.formfactor.desktop(),
            cssClass: 'rsInverted-large'
          });
          return;
        }
      }

      this.model = this.options.model;
      this.match = this.model.get('match');
      this.matchId = this.options.match.matchId;
      this.theme = new svs.sport.themeLoader({
        sport:
          this.match.league && this.match.league.sport
            ? this.match.league.sport.id
            : this.match.sport.id
      });

      this.listenTo(this, 'navigate-tab', this.navigateToTab);

      if (
        this.theme.exist([
          'stat-match-events',
          'stat-match-statistics',
          'stat-match-lineup',
          'stat-general-table'
        ])
      ) {
        this.matchId = this.match.matchId;
        this.setupTabs();
        this.model.set('showFavStar', true, { silent: true });
      }

      this.model.on('sync', this.onModelSync, this);

      svs.core.detect.orientation.on('change', this.onOrientationChange, this);

      this.cbFunc = _.bind(this.initMasonry, this);
      $(window.document).on('resizeTabView', this.cbFunc);
    },

    onOrientationChange: function() {
      this.resizeRoyalSlider();
      this.initMasonry();
    },

    setupTabs: function(preDraw) {
      this.selectedTab = this.options.selectedTab || 'matchinfo';
      this.tabs = [];

      var trotting =
        svs.utils.ns.isNamespace('match.sport.id', this) &&
        this.match.sport.id === svs.statistics.constants.TROTTING;
      if (this.matchId) {
        this.addTabs(
          trotting ? 'Startfält' : 'TT-Nyheter',
          svs.statistics.newstt.views.NewsTTList,
          'nyheter',
          {
            parentId: 'svs-workarea-articles-newstt',
            currentTab: 'NewsTTList',
            domainCategories: 'svs-domain-sport-events/' + this.matchId,
            newsClass: 'statistic-element col-sm-12 col-md-12 padding-md',
            numOfArticles: 100,
            header: trotting ? 'Startfält' : 'Nyheter från TT',
            useTabletGradient: true
          }
        );
      }

      if (preDraw || this.theme.exist(['stat-general-table'])) {
        this.addTabs(
          'Tabell',
          svs.statistics.views.StatGeneralTables,
          'tabell',
          {
            currentTab: 'StatGeneralTables',
            matchId: this.matchId,
            leagueId: this.getLeagueId(),
            parent: this,
            match: this.match
          }
        );
      }

      if (preDraw || this.theme.exist(['stat-match-events'])) {
        trotting =
          svs.utils.ns.isNamespace('match.sport.id', this) &&
          this.match.sport.id === svs.statistics.constants.TROTTING;
        var title = trotting ? 'Loppinfo' : 'Matchinfo';
        var parentId = trotting
          ? 'svs-workarea-articles-analysis-long'
          : undefined;
        this.addTabs(title, svs.statistics.views.StatMatchEvents, 'matchinfo', {
          currentTab: 'StatMatchEvents',
          matchId: this.matchId,
          parent: this,
          parentId: parentId,
          drawNumber:
            this.model && this.model.get('draw')
              ? this.model.get('draw').drawNumber
              : null
        });
      }

      if (preDraw || this.theme.exist(['stat-match-statistics'])) {
        this.addTabs(
          'Statistik',
          svs.statistics.views.StatMatchStatistics,
          'statistik',
          {
            currentTab: 'StatMatchStatistics',
            matchId: this.matchId,
            parent: this,
            forceFetch: true,
            triedToFetch: false
          }
        );
      }

      if (preDraw || this.theme.exist(['stat-match-lineup'])) {
        this.addTabs(
          'Laguppställning',
          svs.statistics.views.StatMatchLineup,
          'laguppstallning',
          {
            currentTab: 'StatMatchLineup',
            matchId: this.matchId,
            leagueId: this.getLeagueId(),
            parent: this
          }
        );
      }
    },

    addTabs: function(caption, viewOrViewClass, id, params) {
      if (this.selectedTab && this.selectedTab === id) {
        this.tabs.push({
          caption: caption,
          view: new viewOrViewClass({ params: params }),
          id: id,
          cssClass: 'slide-inverted'
        });
        this.selectedTab = undefined;
      } else {
        this.tabs.push({
          caption: caption,
          viewClass: viewOrViewClass,
          params: params,
          id: id,
          cssClass: 'slide-inverted'
        });
      }
    },

    navigateToTab: function(arg) {
      if (_.isObject(arg) && _.has(arg, 'tabIndex')) {
        this.statsTab.slider.goTo(arg.tabIndex, true);
      }
    },

    onRender: function() {
      var _self = this;

      if (this.tabs) {
        this.statsTab = new svs.components.Tabs({
          el: this.$el,
          tabs: this.tabs,
          selected: this.options.selectedTab,
          defaultTab: 'matchinfo',
          path: !!this.options.path,
          cacheCreated: true,
          solidNav: this.options.usePageScroll || false,
          defaultScroll: this.options.usePageScroll || false,
          slideOnDrag: !svs.core.detect.formfactor.desktop(),
          cssClass: 'rsInverted-large'
        });

        this.statsTab.on('change', function() {
          _self.resizeRoyalSlider();
        });
      }

      this.postRender();
    },
    postRender: function() {
      setTimeout(function() {
        $(window.document).trigger('resizeTabView');
      }, 500);
    },
    getLeagueId: function() {
      return (
        this.options &&
        this.options.match &&
        this.options.match.league &&
        this.options.match.league.id
      );
    },
    resizeRoyalSlider: function() {
      if (_.isObject(this.statsTab)) {
        this.statsTab.resize();
        this.trigger('resizeRoyalSlider');
      }
    },
    onModelSync: function() {
      this.resizeRoyalSlider();
      this.initMasonry();
    },

    initMasonry: function() {
      var self = this,
        masonryOptions = {
          columnWidth: '.masonry-item',
          itemSelector: '.masonry-item'
        };

      $('.masonry-container').each(function(i) {
        if (self.masonryInstances[i]) {
          self.masonryInstances[i].layout();
        } else {
          self.masonryInstances[i] = new Masonry(this, masonryOptions);
        }
      });
    },

    onDestroy: function() {
      this.clearServerFetchedData();
      svs.core.detect.orientation.off('change', this.onOrientationChange, this);

      if (this.cbFunc) {
        $(window.document).off('resizeTabView', this.cbFunc);
        this.cbFunc = null;
      }

      if (this.tabs) {
        _.each(this.tabs, function(tab) {
          if (tab.view) {
            tab.view.destroy();
          }
        });
      }

      if (this.model) {
        this.model.off();
      }

      if (this.statsTab) {
      }

      this.off();

      if (_.isObject(this.statsTab)) {
        this.statsTab.destroy();
      }

      if (this.model) {
        this.model.dispose();
        this.model.stopListening();
      }

      this.options.model = null;
      this.options = null;
      this.tabs = null;
      this.statsTab = null;
    },


    clearServerFetchedData: function() {
      if ((((svs.statistics || {}).data || {}).matchModels || {}).events) {
        svs.statistics.data.matchModels.events = null;
      }

      if ((((svs.statistics || {}).data || {}).matchModels || {}).statistics) {
        svs.statistics.data.matchModels.statistics = null;
      }

      if ((((svs.statistics || {}).data || {}).matchModels || {}).lineups) {
        svs.statistics.data.matchModels.lineups = null;
      }

      if (
        (((svs.statistics || {}).data || {}).matchModels || {}).leaguetables
      ) {
        svs.statistics.data.matchModels.leaguetables = null;
      }

      if (
        (((svs.statistics || {}).data || {}).matchModels || {})
          .hometeamlatestmatches
      ) {
        svs.statistics.data.matchModels.hometeamlatestmatches = null;
      }

      if (
        (((svs.statistics || {}).data || {}).matchModels || {})
          .awayteamlatestmatches
      ) {
        svs.statistics.data.matchModels.awayteamlatestmatches = null;
      }

      if ((((svs.statistics || {}).data || {}).matchModels || {}).info) {
        svs.statistics.data.matchModels.info = null;
      }
    }
  });
})(Backbone, _, svs);

 })(window);